/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Avatar, Box, Divider, Flex, Image, Spinner, Tab, Table, TableContainer, TabList, TabPanel, TabPanels, Tabs, Tbody, Text, Thead, Tr, useToast } from '@chakra-ui/react'
import { useState, useEffect } from 'react'
import { FaClipboardList, FaEye, FaFilter } from 'react-icons/fa'
import { IoPersonSharp } from 'react-icons/io5'
import { MdGroup, MdGroups } from 'react-icons/md'
import { useNavigate, useParams } from 'react-router-dom'
import { ButtonCmp } from '../../../components/ButtonCmp'
import { ImgSah } from '../../../components/ImgSah'
import LoadingContainer from '../../../components/LoadingContainer'
import { SearchCmp } from '../../../components/SearchCmp'
import { SwitchCmp } from '../../../components/SwitchCmp'
import { Tag } from '../../../components/Tag'
import { WhiteContainer } from '../../../components/WhiteContainer'
import { IDepartment, iNomeId, iTag } from '../../../interfaces'
import { appApi } from '../../../services/appApi'
import { GetNomeItemFeedback, UpdateElementByPosition } from '../../../Utils/Helper'
import { iResultadoPesquisaInterna } from '../../Jornada/PesquisaInterna/Resultado'
import { Body } from '../../Layouts/Body'
import { iResultadoGeralIndicativa } from '../../PesquisaIndicativa/ResultadoGeralIndicativa'
import { iResultadoGeralQuantitativa } from '../../PesquisaPercepcao/ResultadoGeral'
import { BarChart } from './components/BarChart'
import { BarChartAlternativo } from './components/BarChartAlternativo'
import { BarChartCompetencias } from './components/BarChartCompetencias'
import { Carousel } from './components/Carrousel'
import { DrawerFiltro, iFiltro } from './components/DrowerFiltro'
import { PieChart } from './components/PieChart'
import { RadarChartJs } from './components/RadarChart'
import { Recomendacao } from './components/Recomendacao'
import { Tabela } from './components/Tabela'
import { TabelaCompetencias } from './components/TabelaCompetencias'
import WordCloud from './components/WordCloud'
import { ComentariosContainer, ContainerFiltro, InfoBox, OutlineContainer, OutlineTable, StyledSpan, TabelaAvaliacoes, Titulo } from './styles'
import IconeAvaliadores from '../../../assets/IconeTrilha.svg'
import { BarChartGeral } from './components/BarChartGeral'
import { PieChartPesqInterna } from './components/PieChartPesqInterna'
import { BarChartPesqInterna } from './components/BarChartPesqInterna'
import { ModalCalibracoes } from './components/ModalCalibracoes'

interface iModel {
  nome: string
  participantes: iParticipanteFeedback[]
  areas?: IDepartment[]
  statusPorGestor?: iStatusPorGestor[]
  qtdGestores: number
  qtdParticipantes: number
  competenciasTrabalhadas: iCompetenciasTrabalhadas
  statusPDI: iStatusPDI
  percepcoesEmpresaResponse: iPercepcoesEmpresaResponse
  cardsCarousel: iCardCarouselResponse[]
  gestores: iNomeId[]
  tabelaProgresso: iTabelaProgresso
}

export interface iResultadoPesquisa {
  id: string
  nome: string
  tipo: number
  resultadoGeralIndicativa?: iResultadoGeralIndicativa
  resultadoGeralQuantitativa?: iResultadoGeralQuantitativa
  resultadoPesquisaInterna?: iResultadoPesquisaInterna
}

export interface iCompetenciasTrabalhadas {
  qtd: number[]
  labels: string[]
}

interface iStatusPDI {
  preenchidos: iNomeId[]
  aguardandoAprovacao: iNomeId[]
  pendentes: iNomeId[]
}

interface iPercepcoesEmpresaResponse {
  pontosPositivos: iDados
  pontosNegativos: iDados
}

export interface iDados {
  qtd: number[]
  labels: string[]
}

export interface iCardCarouselResponse {
  itemId: string
  tipo: number
  dataInicio: string
  dataFim: string
  nome: string
  ordem?: number
  status: number
  cardAvaliacao: iCardAvaliacaoResponse
  cardCalibracao: iCardCalibracaoResponse
  cardFormulario: iCardFormularioResponse
  cardPDI: iCardPDIResponse
  card9Box: iCard9BoxResponse
  cardReuniao: iCardReuniaoResponse
}

export interface iCardAvaliacaoResponse {
  concluidas: number
  total: number
  eixosRespondentes: iEixosRespondentes[]
  avaliacoesIndividuais: iCardAvaliacaoResponse[]
  dataInicio?: string
  dataFim?: string
  encerrada?: boolean
  nome: string
  status: string
  pesquisaId: string
  colaborador?: iNomeId
}

interface iEixosRespondentes {
  respondidos: number
  total: number
  tipoAvaliador: number
}

interface iCardCalibracaoResponse {
  calibradas: number
  total: number
  calibracoes: iNomeId[]
  dataInicio?: string
  dataFim?: string
  nome: string
  status: string
}

interface iCardFormularioResponse {
  respondidas: number
  total: number
  id: string
  nome: string
  participanteRespondido: number
  gestorRespondido?: number
  participanteTotal: number
  gestorTotal?: number
  dataInicio: string
  dataFim: string
  status: string
  respondentes: iParticipanteRespondente[]
}

export interface iStatusPorGestor {
  gestor: iNomeId
  emAndamento: number
  concluidos: number
}

interface iParticipanteRespondente {
  participante: iNomeId
  participanteRespondeu: boolean
  responsavel?: iNomeId
  responsavelRespondeu?: boolean
}

interface iCardPDIResponse {
  preenchidos: number
  total: number
  pdis: iNomeId[]
  dataInicio?: string
  dataFim?: string
  status: string
}

interface iCard9BoxResponse {
  preenchidos: number
  total: number
  lista: iNomeId[]
  dataInicio?: string
  dataFim?: string
  status: string
}

interface iCardReuniaoResponse {
  realizadas: number
  total: number
  reunioesPendentes: iNomeId[]
  dataInicio?: string
  status?: string
  dataFim?: string
  nome: string
}

interface iTabelaProgresso {
  porcentagem: number
  progressoItens: iProgressoItem[]
}

export interface iProgressoItem {
  porcentagem: number
  nome: string
}

export interface iParticipanteFeedback {
  participante: iNomeId
  responsavel: iNomeId
  departamentoId?: string
  status: number
  itemAtual?: iItemAtualResponse
}

export interface iItemAtualResponse {
  colaboradorId: string
  nomeItemPendente: string
  status: string
}

interface isLoadingItem {
  itemId: string
  base64: string
}

interface isLoadingGrafico {
  itemId: string
  value: boolean
}

export const DashboardGeralFeedback: React.FC = () => {
  const nav = useNavigate()
  const { id } = useParams()
  const toast = useToast()
  const [Ordem, setOrdem] = useState(0)
  const [DrowerIsOpen, setDrowerIsOpen] = useState(false)
  const [IsLoading, setIsLoading] = useState(false)
  const [Calibracoes, setCalibracoes] = useState<iNomeId[]>()
  const [IsLoadingResultados, setIsLoadingResultados] = useState(false)
  const [Model, setModel] = useState<iModel>()
  const [Tags, setTags] = useState<iTag[]>([])
  const [ResultadosPesquisa, setResultadosPesquisa] = useState<iResultadoPesquisa[]>([])
  const [Busca, setBusca] = useState('')
  const [FiltroNotFound, setFiltroNotFound] = useState(false)
  const [Filtro, setFiltro] = useState<iFiltro>()
  const [IsLoadingHierarquia, setIsLoadingHierarquia] = useState(false)
  const [itemAtual, setItemAtual] = useState(0)
  const [GraficoHierarquia, setGraficoHierarquia] = useState<isLoadingGrafico[]>([])
  const colorsGrafico = [
    '#2E93fA',
    '#66DA26',
    '#FF9800',
    '#FF5CAD',
    '#E91E63',
    '#775DD0',
    '#F9CE1D',
    '#009688',
    '#FF4560',
    '#546E7A'
  ]

  function onChangeGraficoHierarquia(val: boolean, itemId: string): void {
    if (GraficoHierarquia.some(e => e.itemId === itemId)) {
      const index = GraficoHierarquia.findIndex(e => e.itemId === itemId)
      const copy = GraficoHierarquia[index]
      copy.value = val
      setGraficoHierarquia(UpdateElementByPosition(GraficoHierarquia, index, copy))
    } else {
      setGraficoHierarquia([...GraficoHierarquia, { itemId: itemId, value: val }])
    }
  }

  function getDashboard(): void {
    setFiltroNotFound(false)
    setIsLoading(true)
    appApi.get(`FeedbackPersonalizado/${id}/Dashboard?departamentoId=${Filtro?.area ?? ''}&gestorId=${Filtro?.gestor ?? ''}&status=${Filtro?.status ?? ''}`)
      .then(res => {
        const data: iModel = res.data
        if (!Model) {
          setModel(data)
        } else {
          setModel({ ...data, areas: Model.areas, gestores: Model.gestores })
        }
        if (data.cardsCarousel && data.cardsCarousel.length > 0) {
          let ordemSelecionada = false
          data.cardsCarousel.forEach((e, i) => {
            if (!ordemSelecionada) {
              switch (e.tipo) {
                case 3:
                case 4:
                  if (e.cardAvaliacao && e.cardAvaliacao.status !== 'Concluída') {
                    setOrdem(i)
                    ordemSelecionada = true
                  }
                  break
                case 5:
                case 15:
                  if (e.cardFormulario && e.cardFormulario.status !== 'Concluída') {
                    setOrdem(i)
                    ordemSelecionada = true
                  }
                  break
                case 11:
                  if (e.cardReuniao && e.cardReuniao.status !== 'Concluída') {
                    setOrdem(i)
                    ordemSelecionada = true
                  }
                  break
                case 13:
                  if (e.cardCalibracao && e.cardCalibracao.status !== 'Concluída') {
                    setOrdem(i)
                    ordemSelecionada = true
                  }
                  break
                case 12:
                  if (e.card9Box && e.card9Box.status !== 'Concluída') {
                    setOrdem(i)
                    ordemSelecionada = true
                  }
                  break
                case 14:
                  if (e.cardPDI && e.cardPDI.status !== 'Concluída') {
                    setOrdem(i)
                    ordemSelecionada = true
                  }
                  break
                default:
                  setOrdem(0)
                  break
              }
            }
          })
        }
      })
      .catch(err => {
        console.log(err)
        if (err.response.status === 404 && (Filtro?.area !== undefined || Filtro?.gestor !== undefined || Filtro?.status !== undefined)) {
          setFiltroNotFound(true)
        }
      })
      .finally(() => setIsLoading(false))
  }

  function getResultados(): void {
    setIsLoadingResultados(true)
    appApi.get(`FeedbackPersonalizado/${id}/Dashboard/Resultados`)
      .then(res => {
        setResultadosPesquisa(res.data)
      })
      .catch(err => {
        console.log(err)
      })
      .finally(() => setIsLoadingResultados(false))
  }

  function onFiltrar(filtro: iFiltro): void {
    if (!Model) return

    const tags: iTag[] = []
    if (filtro.area) tags.push({ id: filtro.area, texto: `Área: ${Model.areas?.find(a => a.id === filtro.area)?.nome}` ?? '' })
    if (filtro.gestor) tags.push({ id: filtro.gestor, texto: `Gestor: ${Model.gestores?.find(a => a.id === filtro.gestor)?.nome}` ?? '' })
    if (filtro.status) tags.push({ id: filtro.status, texto: filtro.status === '4' ? 'Status: Em andamento' : 'Status: Concluídos' })

    setTags(tags)
    setFiltro(filtro)
    setDrowerIsOpen(false)
    toast({
      title: 'Itens filtrados com sucesso',
      duration: 4000,
      position: 'top',
      status: 'success'
    })
  }

  useEffect(() => {
    setIsLoadingHierarquia(true)
    setTimeout(() => {
      setIsLoadingHierarquia(false)
    }, 700)
  }, [GraficoHierarquia])

  function TemColuna(tipo: number, item: iResultadoPesquisa): boolean {
    return item.resultadoGeralQuantitativa?.participantes.includes(tipo) ?? false
  }

  function GetResultado(item: iResultadoPesquisa): any {
    switch (item.tipo) {
      case 3:
        if (!item.resultadoGeralQuantitativa) return <></>
        return (<Flex w={'100%'} flexDir='column'>
          <Flex mb={'1rem'} gap={'.5rem'}>
            <InfoBox>
              <FaClipboardList size={34} />
              <div>
                <Text align={'start'} marginBottom={'-0.325rem'} fontSize={'1.25rem'} fontFamily={'Roboto'} fontWeight={'bold'} >{item.resultadoGeralQuantitativa?.totalRespostas}</Text>
                <span>Respostas</span>
              </div>
            </InfoBox>
            <InfoBox>
              <Flex width={'1rem'} h={'2.5rem'}>
                <Image src={IconeAvaliadores} objectFit={'contain'}/>
              </Flex>
              <div>
                <Text align={'start'} marginBottom={'-0.325rem'} fontSize={'1.25rem'} fontFamily={'Roboto'} fontWeight={'bold'} >{item.resultadoGeralQuantitativa?.totalAvaliadores}</Text>
                <span>Avaliadores</span>
              </div>
            </InfoBox>

            <InfoBox style={{ flexDirection: 'column' }}>
              <Text align={'start'} marginBottom={'-0.125rem'} fontSize={'1.25rem'} fontFamily={'Roboto'} fontWeight={'bold'} >{item.resultadoGeralQuantitativa?.mediaGeral.toFixed(2)}</Text>
              <span>Média dos stakeholders</span>
            </InfoBox>

            <InfoBox style={{ flexDirection: 'column' }}>
              <Text align={'start'} marginBottom={'-0.125rem'} fontSize={'1.25rem'} fontFamily={'Roboto'} fontWeight={'bold'} >{item.resultadoGeralQuantitativa?.mediaAutoavaliacao.toFixed(2)}</Text>
              <span>Média da autoavaliação</span>
            </InfoBox>
          </Flex>
          <Flex w={'100%'}>
            {(GraficoHierarquia.find(e => e.itemId === item.id)?.value && item.resultadoGeralQuantitativa?.escala) && (
              <Flex flexDir={'column'} width='100%'>
                <Flex justifyContent={'space-between'}>
                  <Flex gap={'.75rem'}>
                    <Titulo>Gráfico de hierarquia</Titulo>
                  </Flex>
                  <SwitchCmp value={!!GraficoHierarquia.find(e => e.itemId === item.id)?.value} OnChange={(e) => { onChangeGraficoHierarquia(e, item.id) }} legendaDireita={'Gráfico de hierarquia'} legendaEsquerda={'Gráfico individual'}/>
                </Flex>
                <LoadingContainer linhas={12} loading={IsLoadingHierarquia} my='1rem'>
                  <Flex justifyContent={'center'} width='100%'>
                    <Flex width={item.resultadoGeralQuantitativa?.graficoRadar.competencias.length > 3 ? '50%' : '90%'} mt={item.resultadoGeralQuantitativa?.graficoRadar.competencias.length > 3 ? 0 : '1rem'}>
                      {item.resultadoGeralQuantitativa?.graficoRadar.competencias.length > 3 && <RadarChartJs
                        id={item.id}
                        grafico={item.resultadoGeralQuantitativa?.graficoRadar ?? { competencias: [], dados: [] }}
                        getBlob={(e: string) => {}}
                        escala={item.resultadoGeralQuantitativa?.escala}
                      />}
                      {item.resultadoGeralQuantitativa?.graficoRadar.competencias.length <= 3 && <BarChartAlternativo
                        id={'custom_canvas_background_color_bar_chart' + item.id}
                        labels={item.resultadoGeralQuantitativa?.graficoRadar.competencias ?? []}
                        series={item.resultadoGeralQuantitativa?.graficoRadar.dados ?? []}
                        notaMinimaEscala={0}
                        notaMaximaEscala={Math.max(...item.resultadoGeralQuantitativa?.escala.respostas.map(e => e.peso))}
                        stepSize={((item.resultadoGeralQuantitativa.escala?.respostas[0]?.peso ?? 0) - (item.resultadoGeralQuantitativa.escala?.respostas[1]?.peso ?? 0)) ?? 0}
                        onSetGrafico={(e: string) => {}}
                      />}
                    </Flex>
                  </Flex>
                </LoadingContainer>
              </Flex>
            )}

            {(!GraficoHierarquia.find(e => e.itemId === item.id)?.value && item.resultadoGeralQuantitativa?.escala) && (
              <Flex flexDir={'column'} width='100%'>
                <Flex justifyContent={'space-between'}>
                  <Flex gap={'.75rem'}>
                    <Titulo>Gráfico individual</Titulo>
                  </Flex>
                  <SwitchCmp value={!!GraficoHierarquia.find(e => e.itemId === item.id)?.value} OnChange={(e) => { onChangeGraficoHierarquia(e, item.id) }} legendaDireita={'Gráfico de hierarquia'} legendaEsquerda={'Gráfico individual'}/>
                </Flex>
                <LoadingContainer linhas={12} loading={IsLoadingHierarquia} my='1rem'>
                  <Flex justifyContent={'center'} width='100%'>
                    <Flex width={item.resultadoGeralQuantitativa?.graficoRadar.competencias.length > 3 ? '50%' : '90%'} mt={item.resultadoGeralQuantitativa?.graficoRadar.competencias.length > 3 ? 0 : '1rem'}>
                      {item.resultadoGeralQuantitativa?.graficoRadar.competencias.length > 3 &&
                      <RadarChartJs
                        id={item.id}
                        grafico={
                          {
                            competencias: item.resultadoGeralQuantitativa?.graficoRadar.competencias ?? [],
                            dados: [(item.resultadoGeralQuantitativa?.graficoRadar.dados.find(e => e.nome === 'Autoavaliação') ?? { medias: [], nome: '' }), (item.resultadoGeralQuantitativa?.graficoRadar.dados.find(e => e.nome === 'Média sem autoavaliação') ?? { medias: [], nome: '' })]
                          } ?? { competencias: [], dados: [] }
                        }
                        getBlob={(e: string) => {}}
                        escala={item.resultadoGeralQuantitativa?.escala}
                      />}
                      {item.resultadoGeralQuantitativa?.graficoRadar.competencias.length <= 3 && <BarChartAlternativo
                        id={'custom_canvas_background_color_bar_chart_individual' + item.id}
                        labels={item.resultadoGeralQuantitativa?.graficoRadar.competencias ?? []}
                        series={[(item.resultadoGeralQuantitativa?.graficoRadar.dados.find(e => e.nome === 'Autoavaliação') ?? { medias: [], nome: '' }), (item.resultadoGeralQuantitativa?.graficoRadar.dados.find(e => e.nome === 'Média sem autoavaliação') ?? { medias: [], nome: '' })] ?? []}
                        notaMinimaEscala={0}
                        notaMaximaEscala={Math.max(...item.resultadoGeralQuantitativa?.escala.respostas.map(e => e.peso))}
                        stepSize={((item.resultadoGeralQuantitativa.escala?.respostas[0]?.peso ?? 0) - (item.resultadoGeralQuantitativa.escala?.respostas[1]?.peso ?? 0)) ?? 0}
                        onSetGrafico={(e: string) => {}}
                      />}
                    </Flex>
                  </Flex>
                </LoadingContainer>
              </Flex>
            )}
          </Flex>
          <Divider opacity={'1'} borderColor={'var(--c6)'} mb={'1rem'}/>
          <Flex flexDir={'column'} gap='1rem'>
            <Titulo style={{ marginBottom: '.325rem' }}>Tabela dos resultados por hierarquia</Titulo>
            <Tabela
              linhas={item.resultadoGeralQuantitativa?.tabela ?? []}
              temColuna={(tipo) => TemColuna(tipo, item)}
              mediaGeral={item.resultadoGeralQuantitativa?.mediaGeral}
            />
          </Flex>
          <Divider opacity={'1'} borderColor={'var(--c6)'} mb={'1.25rem'} mt={'2rem'}/>
          <Flex flexDir={'column'}>
            <Flex justifyContent={'space-between'}>
              <Titulo>Competências com maiores potenciais de melhoria</Titulo>
            </Flex>
            <Flex margin={'1rem 0'} gap={'1rem'}>
              {
                item.resultadoGeralQuantitativa.recomendacoes.slice(0, 3).map((e, i) => {
                  return (
                    <Box key={i} as='div' borderRadius={'.25rem'} transition={'.2s'} flex={1} height={'6.75rem'}>
                      <Recomendacao key={i} pos={i + 1} recomendacao={{ id: e.competenciaId ?? '', avatar: e.avatar, nome: e.nome, pergunta: '', colaboradores: e.colaboradores }} />
                    </Box>
                  )
                })
              }
            </Flex>
            {(item.resultadoGeralQuantitativa && item.resultadoGeralQuantitativa?.recomendacoes.length > 3) && (
              <Flex border={'1px solid var(--Gray4)'} borderRadius={'.25rem'}>
                <TabelaCompetencias dados={item.resultadoGeralQuantitativa?.recomendacoes}/>
              </Flex>
            )}
          </Flex>
        </Flex>)
      case 4:
        if (!item.resultadoGeralIndicativa) return <></>
        return (<Flex w={'100%'} flexDir='column'>
          {!!(item.resultadoGeralIndicativa?.totalRespostas) && (
            <Flex gap={'.75rem'}>
              <InfoBox>
                <Flex width={'2rem'}>
                  <img src={IconeAvaliadores} width={'32px'} height={'32px'}/>
                </Flex>
                <div>
                  <Text align={'start'} fontSize={'1.25rem'} lineHeight={'1.325rem'} fontFamily={'Roboto'} fontWeight={'bold'} >{item.resultadoGeralIndicativa?.totalAvaliacoes}</Text>
                  <Text fontSize={'.875rem'}>Avaliados</Text>
                </div>
              </InfoBox>
              <InfoBox>
                <Flex>
                  <FaClipboardList size={28} />
                </Flex>
                <div>
                  <Text align={'start'} fontSize={'1.25rem'} lineHeight={'1.325rem'} fontFamily={'Roboto'} fontWeight={'bold'} >{item.resultadoGeralIndicativa?.totalAvaliadores}</Text>
                  <Text fontSize={'.875rem'}>Avaliadores</Text>
                </div>
              </InfoBox>
              <InfoBox>
                <Flex>
                  <MdGroups size={32}/>
                </Flex>
                <div>
                  <Text align={'start'} fontSize={'1.25rem'} lineHeight={'1.325rem'} fontFamily={'Roboto'} fontWeight={'bold'} >{((item.resultadoGeralIndicativa.totalRespostas / (item.resultadoGeralIndicativa.totalAvaliadores)) * 100).toFixed(0)}%</Text>
                  <Text fontSize={'.875rem'}>Adesão</Text>
                </div>
              </InfoBox>
            </Flex>
          )}
          <Divider opacity={'1'} borderColor={'var(--c6)'} mb={'1.25rem'} mt={'2rem'}/>
          <Flex flexDir={'column'}>
            <Flex justifyContent={'space-between'} mb={'1rem'} alignItems={'center'} fontSize={'1.125rem'}><Text fontWeight={'700'}>Visão das competências considerando todos os avaliados</Text></Flex>
            <Box p={'.5rem 1rem'} border={'1px solid #b9b9b970'} borderRadius={'.25rem'}>
              <TabelaAvaliacoes>
                <thead>
                  <tr>
                    <th>Competências</th>
                    <th>Melhor</th>
                    <th>Pior</th>
                    <th>Mais se motiva</th>
                    <th>Menos se motiva</th>
                    <th>Foi priorizado</th>
                  </tr>
                </thead>
                <tbody>
                  {item.resultadoGeralIndicativa.tabelaVisaoGeral.geralAvaliados?.map(e => {
                    return (
                      <tr>
                        <td>{e.competencia}</td>
                        <td style={{ color: 'green' }}>{e.melhor === '0' ? '-' : e.melhor}</td>
                        <td style={{ color: 'red' }}>{e.pior === '-0' ? '-' : e.pior}</td>
                        <td style={{ color: 'green' }}>{e.maisMotiva === '0' ? '-' : e.maisMotiva}</td>
                        <td style={{ color: 'red' }}>{e.menosMotiva === '-0' ? '-' : e.menosMotiva}</td>
                        <td>{e.priorizado === '0' ? '-' : e.priorizado}</td>
                      </tr>
                    )
                  })}
                </tbody>
              </TabelaAvaliacoes>
            </Box>
          </Flex>
          <Divider opacity={'1'} borderColor={'var(--c6)'} my={'2rem'}/>
          <Flex flexDir={'column'} pb={'1rem'}>
            <Titulo>Média geral das competências</Titulo>
            {!IsLoading && <BarChartGeral
              id={`grafico-indicativa-${item.id}`}
              model={item.resultadoGeralIndicativa.graficoMediaGeralCompetencias}
            />}
            {IsLoading && <LoadingContainer loading={true} linhas={22} my={'1rem'}></LoadingContainer>}
          </Flex>
        </Flex>)
      case 5:
      case 15:
        if (!item.resultadoPesquisaInterna) return <></>
        return <Flex flexDir={'column'}>
          <Flex flexDir={'column'}>
            {item.resultadoPesquisaInterna?.graficos.length > 0 && <Titulo>Respostas</Titulo>}
            {item.resultadoPesquisaInterna?.graficos.map((e, i) => {
              if ((e.series.length <= 8 && e.tipo !== 5)) {
                return (
                  <Flex key={i} flexDir={'column'} width='100%' pt={i === 0 ? '1rem' : '2rem'} pb={'1rem'} borderBottom={i === ((item.resultadoPesquisaInterna?.graficos?.length ?? 0) - 1) ? '' : '1px solid var(--c5)'}>
                    <Flex justifyContent={'space-between'} alignItems={'center'}>
                      <Flex flexDir={'column'}>
                        <Text fontSize={'1rem'}><strong style={{ fontWeight: 900 }}>{i + 1}</strong> - {e.nome}</Text>
                        <Text fontSize={'.813rem'} color={'var(--Gray3)'} ml={'.25rem'} fontWeight={'400'}>Respostas: {e.respostas}</Text>
                      </Flex>
                      {e.media && <Flex alignItems={'center'} justifyContent={'center'} p={'.625rem 1.25rem'} color={'var(--c1)'} bg={'var(--Azul)'} gap={'.325rem'} fontSize={'.875rem'} borderRadius={'.125rem'}>Média: <strong>{e.media.toFixed(2)}</strong></Flex>}
                    </Flex>
                    <Flex pt={'3rem'} justifyContent={'center'} alignItems={'center'} width={'100%'} paddingBottom={'1rem'} marginBottom={'1rem'} gap={'.5rem'}>
                      <PieChartPesqInterna data={e} id={`chart-${item.id}-${i}`} colorsGrafico={colorsGrafico}/>
                      <Flex flexDir={'column'} gap={'.325rem'}>
                        {e.labels.map((label, indexLabel) => {
                          return <Flex gap={'.5rem'} alignItems={'center'} fontSize='14px' fontWeight={400}>
                            <Flex borderRadius={'50%'} w={'.875rem'} h={'.875rem'} bg={colorsGrafico[indexLabel]}></Flex>
                            {label}
                          </Flex>
                        })}
                      </Flex>
                    </Flex>
                  </Flex>
                )
              } else {
                return (
                  <Flex key={i} flexDir={'column'} width='100%' pt={i === 0 ? '1rem' : '2rem'} pb={'1rem'} borderBottom={i === ((item.resultadoPesquisaInterna?.graficos.length ?? 0) - 1) ? '' : '1px solid var(--c5)'}>
                    <Flex flexDir={'column'}>
                      <Text fontSize={'1rem'}><strong style={{ fontWeight: 900 }}>{i + 1}</strong> - {e.nome}</Text>
                      <Text fontSize={'.813rem'} color={'var(--Gray3)'} ml={'.25rem'} fontWeight={'400'}>Respostas: {e.respostas}</Text>
                    </Flex>
                    <Flex justifyContent={'center'} alignItems={'center'} width={'100%'} paddingBottom={'1rem'} marginBottom={'1rem'}>
                      <BarChartPesqInterna data={e} id={`chart-${item.id}-${i}`} />
                    </Flex>
                  </Flex>
                )
              }
            })
            }
            {item.resultadoPesquisaInterna?.graficos.length > 0 && item.resultadoPesquisaInterna.discursivas.length > 0 && item.resultadoPesquisaInterna.discursivas.some(c => c.respostas?.length > 0) && <Divider opacity={'1'} borderColor={'var(--c6)'} mb={'1.25rem'} mt={'2rem'}/>}
            {item.resultadoPesquisaInterna.discursivas.length > 0 && item.resultadoPesquisaInterna.discursivas.some(c => c.respostas?.length > 0) && <>
              {
                item.resultadoPesquisaInterna?.discursivas.map((e, i) => {
                  return (
                    <Box paddingTop={i !== 0 ? '1.5rem' : ''} paddingBottom={i === ((item.resultadoPesquisaInterna?.discursivas.length ?? 0) - 1) ? '' : '1rem'} borderBottom={i === ((item.resultadoPesquisaInterna?.discursivas.length ?? 0) - 1) ? '' : '2px solid var(--c5)'} key={i}>
                      <Flex justifyContent={'space-between'} alignItems={'center'} gap={'1rem'}>
                        <Flex gap={'.325rem'} fontSize={'.925rem'}>
                          <Text fontWeight={'400'}>Pergunta: <strong>{e.pergunta}</strong></Text>
                        </Flex>
                        <Flex alignItems={'center'} gap={'.325rem'} justifyContent={'center'} border={'2px solid var(--Azul)'} p={'.25rem 1rem'} fontSize={'.813rem'} borderRadius={'.25rem'}>
                          Comentários: <strong>{e.respostas.length}</strong>
                        </Flex>
                      </Flex>
                      <ComentariosContainer>
                        <section>
                          {
                            e.respostas.map((e, i) => {
                              return (
                                <div key={i}>
                                  <span key={i}>{e}</span>
                                </div>
                              )
                            })
                          }
                        </section>
                      </ComentariosContainer>
                    </Box>
                  )
                })
              }
            </>}
          </Flex>
        </Flex>
      default:
        return <></>
    }
  }

  useEffect(() => {
    getDashboard()
    getResultados()
  }, [])

  useEffect(() => {
    if (Filtro && (Filtro.area !== undefined || Filtro.gestor !== undefined || Filtro.status !== undefined)) {
      getDashboard()
    }
  }, [Filtro])

  return (
    <Body isLoading={IsLoading}>
      {!Model
        ? <LoadingContainer loading linhas={42}></LoadingContainer>
        : <><DrawerFiltro
        isOpen={DrowerIsOpen}
        areas={Model?.areas ?? []}
        gestores={Model?.gestores ?? []}
        onClose={() => setDrowerIsOpen(false)}
        filtro={Filtro}
        onFilter={(param) => onFiltrar(param)}
      />
      {Calibracoes && <ModalCalibracoes
        isOpen
        calibracoes={Calibracoes}
        isPDI
        onRequestClose={() => { setCalibracoes(undefined) }}
      />}

      <Flex justifyContent={'space-between'} mb={'1rem'}>
        <h1>{Model?.nome}</h1>
      </Flex>

      <WhiteContainer>
          <ContainerFiltro>
            <Flex justifyContent={'space-between'} alignItems={'center'} width={'100%'}>
              <Flex alignItems={'center'}>
                <Text fontWeight={'500'} fontSize='.875rem' paddingRight={'1rem'} borderRight={'2px solid var(--c5)'}>Filtros aplicados</Text>
                <Flex padding={'0 1rem'} gap={'1rem'}>
                  {Tags.length === 0 && <Tag>Todos</Tag>}

                  {
                    Tags.map((e) => {
                      return (
                        <Tag>{e.texto}</Tag>
                      )
                    })
                  }
                </Flex>
              </Flex>
              <Box color='var(--c6)' _hover={{ color: 'var(--Azul)' }}><FaFilter onClick={() => setDrowerIsOpen(true)} cursor={'pointer'} size={22} /></Box>
            </Flex>
          </ContainerFiltro>
      </WhiteContainer>
      <Tabs variant='unstyled' marginTop={'1rem'}>
        <TabList>
          <Tab backgroundColor={'white'} color={'var(--c6)'} borderRadius={'.25rem 0 0 0'} _selected={{ color: 'var(--Azul)', borderBottom: '1px solid var(--Azul)' }}>Dashboard</Tab>
          <Tab backgroundColor={'white'} color={'var(--c6)'} borderRadius={'.25rem 0 0 0'} _selected={{ color: 'var(--Azul)', borderBottom: '1px solid var(--Azul)' }}>Participantes</Tab>
          {IsLoadingResultados
            ? <Tab backgroundColor={'white'} color={'var(--c6)'} borderRadius={'.25rem 0 0 0'} _selected={{ color: 'var(--Azul)', borderBottom: '1px solid var(--Azul)' }}>
            <Flex alignItems={'center'} gap={'.325rem'}>
              Carregando... <Spinner size={'sm'}/>
            </Flex>
          </Tab>
            : ResultadosPesquisa.length > 0
              ? <Tab backgroundColor={'white'} color={'var(--c6)'} borderRadius={'.25rem 0 0 0'} _selected={{ color: 'var(--Azul)', borderBottom: '1px solid var(--Azul)' }}>
            <Flex alignItems={'center'} gap={'.325rem'}>
              Resultados
            </Flex>
          </Tab>
              : null}
        </TabList>
        <TabPanels background={'white'} borderBottomLeftRadius='.25rem' borderBottomRightRadius='.25rem'>
          <TabPanel padding={'1rem'} position={'relative'}>
            <LoadingContainer loading={IsLoading} linhas={36}>
              {!IsLoading && !FiltroNotFound && <Flex flexDir={'column'} gap={'1rem'}>
                <Flex flexDir={'column'} gap={'.5rem'}>
                  <Carousel items={Model.cardsCarousel} feedbackId={id ?? ''} height={180} ordem={Ordem} onChangeOrdem={setOrdem}/>
                  <Flex justifyContent={'center'} gap={'.5rem'}>
                    {Model.cardsCarousel.map((e, i) => {
                      const color = (Ordem === i) ? 'var(--Azul)' : 'var(--c4)'
                      const colorHover = (Ordem === i) ? 'var(--Azul-hover)' : 'var(--c5)'
                      return (<Flex bg={color} _hover={{ bg: colorHover, filter: 'brightness: (1.02)' }} borderRadius={'.125rem'} width={'2.625rem'} h={'.375rem'} cursor={'pointer'} onClick={() => setOrdem(i)}></Flex>)
                    })}
                  </Flex>
                </Flex>
                <Flex flexDir={'column'} gap={'1rem'}>
                  <Flex gap={'1.25rem'}>
                    <InfoBox>
                      <MdGroup size={34} />
                      <div>
                        <Text align={'start'} marginBottom={'-0.325rem'} fontSize={'1.25rem'} fontFamily={'Roboto'} fontWeight={'bold'} >{Model?.participantes.length}</Text>
                        <span>Participantes</span>
                      </div>
                    </InfoBox>
                    <InfoBox>
                      <IoPersonSharp size={34} />
                      <div>
                        <Text align={'start'} marginBottom={'-0.325rem'} fontSize={'1.25rem'} fontFamily={'Roboto'} fontWeight={'bold'} >{Model?.gestores.length}</Text>
                        <span>Gestores</span>
                      </div>
                    </InfoBox>
                  </Flex>
                  <Flex gap={'1.5rem'}>
                    {Model.statusPDI && <OutlineContainer theme={'c4'}>
                      <Flex alignItems={'center'} width={'100%'} flexDir={'column'} gap={'.75rem'} height={'15rem'}>
                        <h3>Status dos PDIs</h3>
                        <PieChart
                          data1={Model.statusPDI.preenchidos.length}
                          data2={Model.statusPDI.pendentes.length}
                          data3={Model.statusPDI.aguardandoAprovacao.length}
                          onChoice={(val) => { if (val === 0) { setCalibracoes(Model.statusPDI.preenchidos.map(e => { return { ...e, respondido: true } })) } else if (val === 1) { setCalibracoes(Model.statusPDI.pendentes) } else { setCalibracoes(Model.statusPDI.aguardandoAprovacao.map(e => { return { ...e, aprovacao: true } })) } }}
                          id='chart-1'
                        />
                      </Flex>
                    </OutlineContainer>}

                    {Model.tabelaProgresso && <OutlineContainer theme={'c4'}>
                      <Flex alignItems={'center'} width={'100%'} flexDir={'column'} gap={'.75rem'} height={'15rem'}>
                        <h3>Porcentagem de conlusão do feedback</h3>
                        <PieChart
                          data1={Model.tabelaProgresso.porcentagem}
                          data2={100 - Model.tabelaProgresso.porcentagem}
                          id='chart-2'
                        />
                      </Flex>
                    </OutlineContainer>}
                  </Flex>
                </Flex>
                {Model.tabelaProgresso?.progressoItens?.some(e => e.porcentagem > 0) && <OutlineContainer theme={'c4'}>
                  <Flex alignItems={'center'} width={'100%'} flexDir={'column'} gap={'.75rem'}>
                    <h3>Porcentagem de conclusão dos itens</h3>
                    <BarChart
                      data={Model.tabelaProgresso.progressoItens}
                      id='chart-progresso-itens'
                    />
                  </Flex>
                </OutlineContainer>}
                {Model.competenciasTrabalhadas && <OutlineContainer theme={'c4'}>
                  <Flex alignItems={'center'} width={'100%'} flexDir={'column'} gap={'.75rem'}>
                    <h3>Competências selecionadas para trabalhar</h3>
                    <BarChartCompetencias
                      data={Model.competenciasTrabalhadas}
                      id='chart-comps-trabalhar'
                    />
                  </Flex>
                </OutlineContainer>}
                {Model.percepcoesEmpresaResponse?.pontosPositivos?.labels?.length > 0 && <Flex gap={'1rem'}>
                  <Flex gap={'1rem'} flexDir='column' w={'100%'}>
                    <OutlineContainer theme={'Green2'} style={{ height: '100%' }}>
                      <Flex alignItems={'center'} width={'100%'} flexDir={'column'} gap={'1.25rem'}>
                        <h3>Principais pontos positivos</h3>
                        <Flex flexDir={'column'} gap={'.325rem'}>
                          {Model.percepcoesEmpresaResponse.pontosPositivos.labels.slice(0, 13).map((e, i) => {
                            return <Text as={'li'} fontWeight={400} fontSize='14px'>{e} - <strong style={{ color: 'var(--Green2)' }}>{Model.percepcoesEmpresaResponse.pontosPositivos.qtd[i]}</strong></Text>
                          })}
                        </Flex>
                      </Flex>
                    </OutlineContainer>
                  </Flex>
                  <OutlineContainer theme={'Green2'}>
                    <Flex alignItems={'center'} width={'100%'} flexDir={'column'} gap={'2rem'}>
                      <h3>Nuvem de palavras</h3>
                      <WordCloud
                        wordsData={Model.percepcoesEmpresaResponse.pontosPositivos}
                      />
                    </Flex>
                  </OutlineContainer>
                </Flex>}
                {Model.percepcoesEmpresaResponse?.pontosNegativos?.labels?.length > 0 && <Flex gap={'1rem'}>
                  <Flex gap={'1rem'} flexDir='column' w={'100%'}>
                    <OutlineContainer theme={'Red'} style={{ height: '100%' }}>
                      <Flex alignItems={'center'} width={'100%'} flexDir={'column'} gap={'1.25rem'}>
                        <h3>Principais pontos negativos</h3>
                        <Flex flexDir={'column'} gap={'.325rem'}>
                          {Model.percepcoesEmpresaResponse.pontosNegativos.labels.slice(0, 13).map((e, i) => {
                            return <Text as={'li'} fontWeight={400} fontSize='14px'>{e} - <strong style={{ color: 'var(--Red)' }}>{Model.percepcoesEmpresaResponse.pontosNegativos.qtd[i]}</strong></Text>
                          })}
                        </Flex>
                      </Flex>
                    </OutlineContainer>
                  </Flex>
                  <OutlineContainer theme={'Red'}>
                    <Flex alignItems={'center'} width={'100%'} flexDir={'column'} gap={'2rem'}>
                      <h3>Nuvem de palavras</h3>
                      <WordCloud
                        wordsData={Model.percepcoesEmpresaResponse.pontosNegativos}
                      />
                    </Flex>
                  </OutlineContainer>
                </Flex>}
              </Flex>}
              {!IsLoading && FiltroNotFound && <ImgSah textoPersonalizado='Não foi encontrado nenhum resultado com esses filtros, tente uma combinação diferente' center></ImgSah>}
            </LoadingContainer>
          </TabPanel>
          <TabPanel padding={'1rem'} position={'relative'}>
            <LoadingContainer loading={IsLoading} linhas={36}>
              {!IsLoading && !FiltroNotFound && <Flex flexDir={'column'} gap={'1rem'}>
                <Flex justifyContent={'space-between'}>
                  <h3>Lista de participantes</h3>
                  <SearchCmp width='22rem' OnChange={setBusca} EnterAction={() => {}} placeholder={'Buscar pelo nome do participante ou responsável'}/>
                </Flex>
                <OutlineTable>
                  <TableContainer>
                    <Table variant='simple'>
                      <Thead>
                        <Tr _hover={{ bg: 'var(--c1) !important', color: 'black' }}>
                          <th>Participante</th>
                          <th>Responsável</th>
                          <th>Status</th>
                          <th>Item atual</th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {Model.participantes.filter(e => {
                          if (Busca !== '') {
                            if (e.participante.nome.toLowerCase().includes(Busca.toLowerCase())) {
                              return e
                            }
                            if (e.responsavel.nome.toLowerCase().includes(Busca.toLowerCase())) {
                              return e
                            }

                            return null
                          }

                          return e
                        })?.map((e, i) => {
                          return (
                            <Tr key={i}>
                              <td>
                                <StyledSpan>
                                  <Avatar size={'sm'} src={e.participante.avatar}/>
                                  <Text color={'Gray1'} fontSize={'12px'} fontWeight={'400'}>{e.participante.nome}</Text>
                                </StyledSpan>
                              </td>
                              <td>
                                <StyledSpan>
                                  <Avatar size={'sm'} src={e.responsavel.avatar}/>
                                  <Text color={'Gray1'} fontSize={'12px'} fontWeight={'400'}>{e.responsavel.nome}</Text>
                                </StyledSpan>
                              </td>
                              <td>
                                <StyledSpan>
                                  <Text
                                    borderRadius={'6px'}
                                    color={'#fff'}
                                    bgColor={e.status === 0 ? 'var(--Red)' : 'var(--Green2)'}
                                    px={'.5rem'} h={'1.4rem'}
                                    fontSize={'12px'}
                                    fontWeight={'400'}
                                  >
                                    {e.status === 0 ? 'Em andamento' : 'Concluído'}
                                  </Text>
                                </StyledSpan>
                              </td>
                              <td>
                                <StyledSpan>
                                  <Text wordBreak={'break-all'} as={Flex} maxW={'17rem'} color={e.itemAtual ? 'var(--Gray2)' : 'var(--Green2)'} fontSize={'12px'} fontWeight={'400'}>{e.itemAtual?.nomeItemPendente ?? 'Todos os itens foram concluídos'}</Text>
                                </StyledSpan>
                              </td>
                              <td>
                                <StyledSpan>
                                  <ButtonCmp small onClick={() => nav(`${e.participante.id}/Participante`)} VarColor='Green2' leftIcon={<FaEye/>}>Visualizar dashboard</ButtonCmp>
                                </StyledSpan>
                              </td>
                            </Tr>
                          )
                        })}
                      </Tbody>
                    </Table>
                  </TableContainer>
                </OutlineTable>
              </Flex>}
              {!IsLoading && FiltroNotFound && <ImgSah textoPersonalizado='Não foi encontrado nenhum resultado com esses filtros, tente uma combinação diferente' center></ImgSah>}
            </LoadingContainer>
          </TabPanel>
          {IsLoadingResultados && <TabPanel padding={'1rem'} position={'relative'}>
            <LoadingContainer linhas={32} loading></LoadingContainer>
          </TabPanel>}
          {ResultadosPesquisa.length > 0 && <TabPanel padding={'1rem'} position={'relative'}>
            <Flex gap={'.75rem'} mb={'1.25rem'}>
              {!IsLoadingResultados && ResultadosPesquisa.map((e, i) => {
                return <Flex borderRadius={'.25rem'} border={'1px solid var(--Azul)'} cursor={'pointer'} _hover={{ bg: 'var(--Azul-hover)', color: 'var(--c1)' }} py={'.325rem'} px={'.75rem'} bg={i === itemAtual ? 'var(--Azul)' : undefined} color={i === itemAtual ? 'var(--c1)' : undefined} onClick={() => setItemAtual(i)} flexDir='column' lineHeight={'14px'}>
                  <Text fontWeight={600} fontSize={'14px'}>{e.nome}</Text>
                  <Text fontWeight={400} fontSize={'12px'}>{GetNomeItemFeedback(e.tipo === 15 ? 5 : e.tipo)}</Text>
                </Flex>
              })}
            </Flex>
            {GetResultado(ResultadosPesquisa[itemAtual])}
          </TabPanel>}
        </TabPanels>
      </Tabs></>}
    </Body>
  )
}
